import axios from 'axios';
import { Dialog } from 'primereact/dialog';
import React, { useState, useEffect } from 'react'
import MaintenanceForm from './MaintenanceForm';
import { API_END_POINT } from '../../config';
import Loader from '../../components/Loader/Loader';

const MaintenanceDialog = ({ visible, onHide, mode, selectedRowData, toast, email }) => {
    const [modules, setModules] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [localFormData, setLocalFormData] = useState({
        maintenanceTitle: '',
        moduleId: '',
        startDate: null,
        endDate: null
    });

    const fetchData = async () => {
        try {
            const res = await axios.get(`${API_END_POINT.BASE_URL.CI_SERVICE}/api/module/list`);
            setModules(res.data.content);
            setIsLoading(false);

        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to load Modules', life: 3000 });
            setIsLoading(false);

        }
    }


    useEffect(() => {
        if (visible) {
            fetchData()
        }
    }, [visible])

    return (
        <>
            {visible && isLoading ? (<Loader />)
                : (<Dialog
                    header={mode === 'edit' ? 'Edit Maintenance' : 'Create Maintenance'}
                    visible={visible}
                    style={{ width: '35vw' }}
                    onHide={() => onHide(false)}>

                    <MaintenanceForm
                        mode={mode}
                        selectedRowData={selectedRowData}
                        modules={modules}
                        onClose={onHide}
                        email={email}
                    />

                </Dialog>)
            }
        </>
    )
}

export default MaintenanceDialog